/**
 * Media fields can contain a public path, a remote/data URL, or a raw Convex
 * storage id. Keep public assets intact and proxy only raw storage ids.
 */
export function resolveMediaUrl(value?: string | null, fallback = ""): string {
  const source = typeof value === "string" ? value.trim() : "";
  if (!source) return fallback;
  if (
    source.startsWith("/") ||
    source.startsWith("http://") ||
    source.startsWith("https://") ||
    source.startsWith("data:") ||
    source.startsWith("blob:")
  ) {
    return source;
  }
  return `/api/storage/${encodeURIComponent(source)}`;
}
